module.exports = __webpack_public_path__ + "img/2_32.dd8c5f27.png";